export default function DocumentHistory() {
  return (
    <section className="sales-layout__page">
      <h1>Beleghistorie</h1>
      <p>Die Beleghistorie ist in Vorbereitung.</p>
    </section>
  );
}
